// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"FAQ_headerWrapper__j9Gyv","accordionItem":"FAQ_accordionItem__1WpJ3","accordionHeader":"FAQ_accordionHeader__3tsYs","collapsed":"FAQ_collapsed__NXxs_"};